import React, { useEffect, useState } from 'react';
import memberLogo from '../../assets/images/Member.png';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";
import { getAgentService } from '../../services/agent.service';
import { FiSearch, FiPlus, FiEye } from 'react-icons/fi'; // react-icons သုံးရန် အကြံပြုပါသည်

const Agent = () => {
    const [agentData, setAgentData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();

    const getAgentData = async (signal) => {
        dispatch(setIsLoading(true));
        try {
            const result = await getAgentService(signal);
            if (result.data) {
                const sortedData = result.data.sort((a, b) => a.remain - b.remain);
                setAgentData(sortedData);
                setFilteredData(sortedData);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error?.includes('streaming buffer')
                ? 'BigQuery streaming buffer: Please Wait and try again later'
                : error?.response?.data?.message || error?.message;

            dispatch(setToastMessage({ message: errorMessage, type: "error" }));
        } finally {
            dispatch(setIsLoading(false));
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            const filtered = agentData.filter((agent) =>
                agent.agentName.toLowerCase().includes(search.toLowerCase()) ||
                agent.username?.toLowerCase().includes(search.toLowerCase())
            );
            setFilteredData(filtered);
        }, 400);
        return () => clearTimeout(timer);
    }, [search, agentData]);

    useEffect(() => {
        const controller = new AbortController();
        getAgentData(controller.signal);
        return () => controller.abort();
    }, []);

    return (
        <div className='px-4 py-2 bg-[#F8FAFC] min-h-[88vh] text-slate-700 text-sm'>
            {/* Breadcrumb Section */}
            {/* <div className='flex items-center gap-2 mb-2'>
                <img src={memberLogo} alt='Logo' className='w-5 h-5 opacity-70' />
                <span className='text-gray-400'>/</span>
                <span className='font-semibold text-slate-800 text-lg'>Agent List</span>
            </div> */}

            {/* Action Bar */}
            <div className='bg-white p-3 rounded-xl shadow-sm border border-slate-200 mb-2 flex flex-col md:flex-row justify-between items-center gap-2'>
                <div className='flex gap-2 w-full md:w-auto'>
                    <Link to="/addnewagent" className='flex-1 md:flex-none'>
                        <button className='flex items-center justify-center gap-2 bg-primary text-white px-5 py-2.5 rounded-lg hover:bg-opacity-90 transition-all text-sm font-medium w-full'>
                            <FiPlus /> Add Agent
                        </button>
                    </Link>
                    <Link to="/business-type" className='flex-1 md:flex-none'>
                        <button className='flex items-center justify-center gap-2 border border-primary text-primary px-5 py-2.5 rounded-lg hover:bg-primary hover:text-white transition-all text-sm font-medium w-full'>
                            Business Type
                        </button>
                    </Link>
                </div>

                <div className='relative w-full md:w-72'>
                    <FiSearch className='absolute left-3 top-1/2 -translate-y-1/2 text-gray-400' />
                    <input
                        type="text"
                        placeholder='Search agent or username...'
                        className='w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg outline-none focus:border-primary focus:ring-2 focus:ring-primary/10 transition-all text-sm'
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
            </div>

            {/* Data Table Card */}
            <div className='bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden'>
                <div className='overflow-x-auto max-h-[70vh]'>
                    <table className='w-full text-left border-collapse'>
                        <thead className='sticky top-0 bg-slate-50 border-b border-slate-200 z-10'>
                            <tr>
                                <th className='px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500'>No.</th>
                                <th className='px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500'>Agent Details</th>
                                <th className='px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500 hidden md:table-cell'>User Name</th>
                                <th className='px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500 text-right'>Balance (Remain)</th>
                                <th className='px-6 py-4 text-xs font-bold uppercase tracking-wider text-slate-500 text-center'>Actions</th>
                            </tr>
                        </thead>
                        <tbody className='divide-y divide-slate-100'>
                            {filteredData.length > 0 ? (
                                filteredData.map((data, index) => (
                                    <tr key={data.agentId} className='hover:bg-blue-50/30 transition-colors group'>
                                        <td className='px-6 py-2 text-sm text-slate-500'>{index + 1}</td>
                                        <td className='px-6 py-2'>
                                            <div className='font-semibold text-slate-800'>{data.agentName}</div>
                                            <div className='text-xs text-slate-400 md:hidden'>{data.username}</div>
                                        </td>
                                        <td className='px-6 py-2 text-sm text-slate-600 hidden md:table-cell'>{data.username}</td>
                                        <td className={`px-6 py-2 text-right font-mono font-medium ${data.remain >= 0 ? 'text-emerald-600' : 'text-rose-600'}`}>
                                            {Number(Math.round(data.remain)).toLocaleString()}
                                        </td>
                                        <td className='px-6 py-2 text-center'>
                                            <Link 
                                                to={`/viewAgent/${data.agentId}`}
                                                className='inline-flex items-center gap-1 text-primary hover:text-white hover:bg-primary border border-primary/20 px-3 py-1.5 rounded-md transition-all text-xs font-medium'
                                            >
                                                <FiEye size={14} /> View
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="px-6 py-10 text-center text-slate-400">
                                        No agents found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Agent;